export const MEMBERSHIP_LIST_SEARCH = {
  q: '',
  status: 'all' as const,
  source: 'all' as const,
  queue: 'all' as const,
  page: 1,
  sort: 0,
};

export const MEMBERSHIP_DETAIL_SEARCH = {
  ...MEMBERSHIP_LIST_SEARCH,
  tab: 'overview' as const,
};
